<template>
  <div v-if="plate">
    <h3>Product plate</h3>

    <v-tabs v-model="isTerm">
      <v-tab>Final Expense</v-tab>
      <v-tab :disabled="branch">TERM</v-tab>
    </v-tabs>

    <template v-if="isTerm">
      <v-checkbox
        label="The product is a Top-Of-The-Line Term Life insurance policy."
        v-model="plate.isProduct"
      />

      <v-checkbox
        label="It allows you to protect large responsibilities, at a small monthly cost."
        v-model="plate.isAllows"
      />

      <v-checkbox
        label="Tha rates NEVER increases during the term. And the coverage amount
         never decrease during the term."
        v-model="plate.isIncreases"
      />

      <v-checkbox
        label="It offers day one coverage with no waiting periods or exclusions."
        v-model="plate.isOffers"
      />

      <v-checkbox
        label="So in the event of something happening, YOUR beneficiary
          would need two forms of ID and the death certificate and the money will be paid
          out tax free. Does that make sense?"
        v-model="plate.isCertificate"
      />
    </template>
    <template v-else>
      <v-checkbox
        label="The product is a Top-Of-The-Line Whole Life Insurance policy"
        v-model="plate.isFexProduct"
      />

      <v-checkbox
        label="It has a high value saving account, so monthly you're saving money 
        in a separate account."
        v-model="plate.isFexValue"
      />

      <v-checkbox
        label="The rates never increase, and the coverage never decreases"
        v-model="plate.isFexIncrease"
      />

      <v-checkbox
        label="This product also includes a HUGE benefit at no additional cost:"
        v-model="plate.isFexBenefit"
      />

      <div class="questions-inner">
        <v-checkbox
          label="Accelerated Death Benefit"
          v-model="plate.isFexAccelerated"
        />

        <p>
          If you're diagnosed with a terminal or chronic illness, you can
          receive up to 80% of the full death benefit while you're still alive.
          That money could be used for experimental treatment, or used to make
          memories and enjoy love'd ones
        </p>
      </div>

      <v-checkbox
        label="This product also includes ability to cover your Children Or 
          Grandchildren up to age 25."
        v-model="plate.isFexCover"
      />

      <v-checkbox
        label="And we also can schedule your premiums for any day of the week so it
          matches with your income or Social Security Benefit. Whatever is convenient
          to You! I assume you get paid on the 1st 2nd 3rd of the month or the 2nd 3rd
          or 4th Wednesday?"
        v-model="plate.isFexSchedule"
      />
    </template>

    <PlateFooter :onBack="onBack" :onSubmit="onSubmit" :isLoading="isLoading" />
  </div>
</template>

<script>
import { format } from 'date-fns';
import { PlatesSteps } from '@/common/variables';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductPlate',
  components: {
    PlateFooter,
  },
  props: {
    agent: {
      type: Object,
    },
    lead: {
      type: Object,
    },
  },
  data: () => ({
    plate: null,
    isTerm: false,
    isLoading: false,
  }),
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.product
    );
    this.plate = data;
    this.isTerm = this.branch ? 0 : 1;
  },
  computed: {
    ...mapGetters({
      branch: 'plates/branch',
    }),
  },
  methods: {
    format,
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.company);
    },
    onSubmit() {
      this.$store.commit('plates/setStep', PlatesSteps.result);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
};
</script>

<style scoped lang="scss">
.questions-inner {
  margin-left: 60px;
}

.input-short {
  max-width: 300px;
}
</style>